import AudioHigh from './AudioHigh';
import AudioLow from './AudioLow';
import AudioOff from './AudioOff';
import Check from './Check';
import ChevronNext from './ChevronNext';
import ChevronPrev from './ChevronPrev';
import Close from './Close';
import ClosedCaption from './ClosedCaption';
import FilledStar from './FilledStar';
import FullScreen from './FullScreen';
import MoreVertIcon from './MoreVertIcon';
import Next from './Next';
import Pause from './Pause';
import Play from './Play';
import PlayCircle from './PlayCircle';
import Prev from './Prev';
import ReplayCircle from './ReplayCircle';
import RestoreScreen from './RestoreScreen';
import Speed from './Speed';
import UnfilledStar from './UnfilledStar';
import AudioPlay from './AudioPlay';
import AudioPause from './AudioPause';
import TocAudioPlay from './TocAudioPlay';
import TocAudioPause from './TocAudioPause';
import AudioForward from './AudioForward';
import AudioRewind from './AudioRewind';
import UCAPlay from './UCAPlay';
import UCAPause from './UCAPause';
import Maximize from './Maximize';
import Minimize from './Minimize';
import NavAudioPause from './NavAudioPause';
import NavAudioPlay from './NavAudioPlay';
import NavClose from './NavClose';
import NavAudioHigh from './NavAudioHigh';
import NavAudioLow from './NavAudioLow';
import NavAudioOff from './NavAudioOff';

export default {
  AudioHigh,
  AudioLow,
  AudioOff,
  Check,
  ChevronNext,
  ChevronPrev,
  Close,
  ClosedCaption,
  FilledStar,
  FullScreen,
  MoreVertIcon,
  Next,
  Pause,
  Play,
  PlayCircle,
  Prev,
  ReplayCircle,
  RestoreScreen,
  Speed,
  UnfilledStar,
  AudioPlay,
  AudioPause,
  TocAudioPlay,
  TocAudioPause,
  AudioForward,
  AudioRewind,
  UCAPlay,
  UCAPause,
  Maximize,
  Minimize,
  NavAudioPause,
  NavAudioPlay,
  NavClose,
  NavAudioHigh,
  NavAudioLow,
  NavAudioOff
};



// WEBPACK FOOTER //
// ./src/js/icons/index.js